module.exports = __webpack_public_path__ + "img/hipercard-v2.868b6df5.svg";